import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PersonPaymentForm, PersonVisitForm } from 'src/app/models/iregistration.interface';
import { FormsService } from 'src/app/services/common/forms.service';

@Component({
  selector: 'app-person-conference-payment-dialog',
  templateUrl: './person-conference-payment-dialog.component.html',
  styleUrls: ['./person-conference-payment-dialog.component.css']
})
export class PersonConferencePaymentDialogComponent implements OnInit {

  data: PersonPaymentForm;
  form: UntypedFormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _frm: FormsService
  ) { }

  ngOnInit(): void {
    this.data = this.config.data;
    this.form = this._frm.createPaymentForm(this.data);
  }

  onCancel() {
    this.ref.close();
  }

  onSubmit() {
    const data = this.form.value as PersonPaymentForm;
    this.ref.close(data);
  }

}
